import { Component, OnInit } from '@angular/core';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Comanda } from 'src/app/admihair/api/dto/comanda';
import { ActivatedRoute } from '@angular/router';
import { ComandaService } from 'src/app/admihair/service/comanda.service';
import { ItemComandaService } from 'src/app/admihair/service/item-comanda.service';
import { ItemComanda } from 'src/app/admihair/api/dto/item-comanda';
import { PagamentoComandaService } from 'src/app/admihair/service/pagamento-comanda.service';
import { PagamentoComandaResponse } from 'src/app/admihair/api/dto/pagamento-comanda-response';
import { AdmihairBaseComponent } from '../../admihair-base.component';

@Component({
  selector: 'app-comanda-detalha-janela',
  templateUrl: './comanda-detalhar-janela.component.html',
  styleUrls: ['./comanda-detalhar-janela.component.scss']
})
export class ComandaDetalharJanelaComponent extends AdmihairBaseComponent implements OnInit {

  id?: number;
  comanda?: Comanda;
  totalItensComanda: number = 0;
  listaItensComanda: ItemComanda[] = [];
  listaPagamentos: PagamentoComandaResponse[] = [];
  loadingPagamento: boolean = false;
  totalPagamentos: number = 0;
  saldoComanda: number = 0;
  valorTotalItensComDesconto: number = 0;
  valorTotalItensSemDesconto: number = 0;

  constructor(private comandaService: ComandaService,
    private itemComandaService: ItemComandaService,
    private pagamentoComandaService: PagamentoComandaService,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService) {
      super(erroService,storageService)
     }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.carregarIdComanda();
    this.carregarComanda();
  }

  carregarIdComanda(){
    const idParam = this._activatedRoute.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
  }

  

  carregarComanda() {
    this.comandaService.buscarPorId(this.id).subscribe({
      next: (data: Comanda) => {
        this.comanda = data;
        this.carregarItensComanda();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  carregarItensComanda() {
    this.itemComandaService.listarPorEmpresaIdEControle(this.getEmpresa().id, this.comanda?.id).subscribe({
      next: (data: ItemComanda[]) => {
        this.listaItensComanda = data;
        this.listarPagamentosFluxo();
        this.calcularTotalItensComanda();
        this.setExibirSpinnerPrincipal(false);
        
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  


  listarPagamentosFluxo() {
    this.pagamentoComandaService.listarPorControle(this.comanda?.id).subscribe({
      next: (data: PagamentoComandaResponse[]) => {
        this.listaPagamentos = data;
        this.calcularTotalPagamentos();
        this.setExibirSpinnerPrincipal(false);
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  calcularTotalItensComanda() {
    this.valorTotalItensComDesconto = 0;
    this.valorTotalItensSemDesconto = 0;
    for (let item of this.listaItensComanda) {
      if(!item.utilizacaoPacote) {
        this.valorTotalItensComDesconto = this.valorTotalItensComDesconto + (item.valorTotalItem ?? 0);
        this.valorTotalItensSemDesconto = this.valorTotalItensSemDesconto + (item.valorItem ?? 0) * (item.quantidadeItem ?? 0);
      }
    }
  }


  calcularTotalPagamentos() {
    this.totalPagamentos = this.listaPagamentos.reduce((total, pagamento) =>
      total + (pagamento.valorFluxo || 0), 0);
    this.calcularSaldoComanda();
  }

  calcularSaldoComanda() {
    this.saldoComanda = this.totalPagamentos - this.totalItensComanda;
  }
  

  calcularSaldoCliente(): number {
    let saldo = this.comanda?.cliente?.saldoConta ?? 0;
    saldo = saldo - this.saldoComanda;
    return saldo * (-1);
  }

}
